<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
            </div>
          </div>
          <div id="details" class="row">
            <div class="col-sm-12 text-right">
              <button
                class="btn btn-danger mr-5"
                type="button"
                @click="deleteDeviceModal"
                v-permission.if="[USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.GA_HEAD]"
              >Delete Device</button>
            </div>
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.brand)"
                  >
                    <label>Brand</label>
                    <input
                      type="text"
                      minlength="3"
                      name="brand"
                      class="form-control"
                      required
                      v-model.lazy="device.brand"
                      placeholder="Brand Name"
                    />
                    <field-messages
                      name="brand"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Brand name is a required field</div>
                      <div slot="pattern">Brand name is invalid</div>
                      <div slot="minlength">Minimum length of brand is 3 character</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.deviceModel)"
                  >
                    <label>Model</label>
                    <input
                      type="text"
                      name="deviceModel"
                      class="form-control"
                      required
                      v-model.lazy="device.deviceModel"
                      placeholder="Model"
                    />
                    <field-messages
                      minlength="3"
                      name="deviceModel"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Model is a required field</div>
                      <div slot="pattern">Model is invalid</div>
                      <div slot="minlength">Minimum length of model is 3 character</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.imei)"
                  >
                    <label>IMEI</label>
                    <input
                      type="number"
                      name="imei"
                      minlength="14"
                      class="form-control"
                      v-model.lazy="device.imei"
                      placeholder="IMEI"
                    />
                    <field-messages
                      name="imei"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <!-- <div slot="required">IMEI is a required field</div> -->
                      <div slot="pattern">IMEI is invalid</div>
                      <div slot="minlength">Minimum 14 number required</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.connectionId)"
                  >
                    <label>Connection Id</label>
                    <input
                      type="number"
                      name="connectionId"
                      minlength="14"
                      class="form-control"
                      v-model.lazy="device.connectionId"
                      placeholder="Connection ID"
                    />
                    <field-messages
                      name="connectionId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <!-- <div slot="required">Connection ID is a required field</div> -->
                      <div slot="pattern">Connection ID is invalid</div>
                      <div slot="minlength">Minimum 14 number required</div>
                    </field-messages>
                  </validate>
                </div>
                
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.deviceId)"
                  >
                    <label>Device ID</label>
                    <input
                      type="text"
                      minlength="3"
                      name="deviceId"
                      class="form-control required-field"
                      required
                      v-model.lazy="device.deviceId"
                      placeholder="Device ID"
                    />
                    <field-messages
                      name="deviceId"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Device ID is a required field</div>
                      <div slot="pattern">Device ID is invalid</div>
                      <div slot="minlength">Minimum length of Device is 3 character</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <label for="dateAdded">Registration Date</label>
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.dateAdded)"
                  >
                    <date-picker
                      required
                      id="dateAdded"
                      v-model="device.dateAdded"
                      lang="en"
                      name="dateAdded"
                      input-class="form-control"
                      width="100%"
                      use-utc="true"
                      format="DD-MM-YYYY"
                    ></date-picker>
                    <field-messages
                      name="dateAdded"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Registration date is a required field</div>
                      <div slot="pattern">Registration date is invalid</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate class="form-group" :class="fieldClassName(formstate.deviceDescription)">
                    <label>Description</label>
                    <textarea
                      class="form-control"
                      name="description"
                      v-model.lazy="device.deviceDescription"
                      placeholder="Description"
                    ></textarea>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate
                    auto-label
                    class="form-group required-field"
                    :class="fieldClassName(formstate.status)"
                  >
                    <label>Status</label>
                    <select v-model="device.status" name="status" class="form-control">
                      <option value disabled>Select Status</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                    <field-messages
                      name="status"
                      show="$touched || $submitted"
                      class="form-control-feedback"
                    >
                      <div slot="required">Status is a required field</div>
                      <div slot="pattern">Status date is invalid</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'Devices' }">
                <button class="mr-5 btn btn-default" type="button">Cancel</button>
              </router-link>
              <button
                class="mr-2 btn gradientbt"
                type="submit"
                @click="updateDevice"
                :disabled="!(formstate.$dirty)"
                v-permission.if="[USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
              >Update Device</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { formService, eventBus, deviceService } from '../../../services';
import { EVENTS } from '../../../config';
import swal from 'sweetalert2';

export default {
  name: 'DeviceDetail',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      role: {},
      roles: [],
      permissions: [],
      formstate: {},
      device: {
        status: 'active',
      },
    };
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    getDevice() {
      return this.$deviceDataRepository
        .find(this.$route.params._id)
        .then(response => {
          this.device = response.data;
        })
        .catch(error => {
          this.$snotify.error('Device detail failed', 'Error!');
        });
    },
    updateDevice() {
      this.loading = true;
      return deviceService
        .updateDevice(this.device)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('Device details updated!', 'Success!');
          this.$router.push('/device');
        })
        .catch(error => {
          this.loading = false;
          console.error('DeviceCreate.createDevice-error:', error);
          this.$snotify.error('Add Device failed', 'Error!');
          if (error.data.message.includes('must be one of')) {
            this.flash = true;
            this.flashType = 'error';
            this.flashMessage =
              'Device is not updated due to some error. Please try again!.';
          }
        });
    },
    deleteDeviceModal() {
      swal({
        title: 'Are you sure?',
        text: 'This will permanently delete this Device!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.value) {
          this.deleteDevice();
        }
      });
    },
    deleteDevice() {
      this.loading = true;
      return this.$deviceDataRepository
        .deleteOne(this.device._id)
        .then(response => {
          this.loading = false;
          return swal('Deleted!', 'Device has been deleted.', 'success');
        })
        .then(response => {
          this.loading = false;
          this.$router.push('/device');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Delete device failed', 'Error!');
        });
    },
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
  },
  created() {
    const promises = [];
    this.loading = true;
    promises.push(this.getDevice());
    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>
<style scoped>
.required-field > label::after,
label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}
.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}
.has-danger {
  color: red;
}
.swal2-popup {
  font-size: 2rem !important;
}
.gradientbt {
  color: white;
  background: #0F6940;

}
</style>



// WEBPACK FOOTER //
// DeviceDetail.vue?d8987308